import React from 'react'
import { Route, Switch } from 'react-router-dom'

import {
    NotifierContainer,
    SnackbarContainer,
} from '@softwaredev_cegeka/stix-notifier'

import { routeConfig } from '../config'
import ErrorBoundary from 'src/components/ErrorBoundary'
import Header from 'src/components/Header'
import Footer from 'src/components/Footer'
import withUserData from 'src/components/auth/withUserData'
import { NotFound, InternalServerError } from '../Error'
import { ContentRoute } from '../ContentRoute'
import UnauthorizedContent from '../UnauthorizedContent'
import styles from './main.module.scss'

class Main extends React.Component {
    render() {
        return (
            <div className={'page-wrapper'}>
                <div className={'page-content'}>
                    <NotifierContainer
                        position="fixed"
                        defaults={{
                            autohide: true,
                            delay: 5000,
                            position: 'fixed',
                        }}
                    />
                    <Header />
                    {/*this needs to be outside because we redirect to it from the ErrorBoundary*/}
                    <Route
                        exact
                        path={'/internal-error'}
                        component={InternalServerError}
                    />
                    <Route>
                        <ErrorBoundary>
                            <Switch>
                                {routeConfig.map((route, index) => {
                                    if (route.permissions instanceof Function) {
                                        if (
                                            !route.permissions(
                                                this.props.userData
                                            )
                                        )
                                            return (
                                                <Route
                                                    path={route.path}
                                                    component={
                                                        UnauthorizedContent
                                                    }
                                                />
                                            )
                                    }
                                    return (
                                        <ContentRoute
                                            key={index}
                                            match={this.props.match}
                                            path={route.path}
                                            component={route.component}
                                            title={route.title}
                                            name={route.name}
                                            breadcrumbs={route.breadcrumbs}
                                        />
                                    )
                                })}
                                {/*TODO fix not found route*/}
                                <Route component={NotFound} />
                            </Switch>
                        </ErrorBoundary>
                    </Route>
                </div>
                <div className={'page-footer'}>
                    <Footer />
                    <SnackbarContainer
                        className={styles.snackbarContainer}
                        defaults={{
                            delay: 5000,
                            position: 'absolute',
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default withUserData(Main)
